module.exports = __webpack_public_path__ + "img/user-6.d4cd82be.jpg";